// "standard" is the default when changing templates.
// One layout for each template enum must be called "standard" so that switch will happen correctly.

// All the other layout names are arbitrary
// Since there can be different numbers of layouts for different tempaltes,
// the enums need to be individually created instead of dynamically mapped.

//When you make a new layout enum, please add it to AllLayoutTypes and LayoutTypesMap 
//at the bottom of the file so they can be dynamically generated in the makeLayoutSelectors function

import { PageModuleType } from "./working-model";


//Classic, Bold, and Fun and decrecated tempalte names, they are here for backwards comppatability purposes, but should not be used moving forward
export enum TemplateNames {
	Classic = 'Apollo',
	Bold = 'Studio 54',
	Fun = 'O2',
	Apollo = "Apollo",
	Studio54 = "Studio 54",
	O2 = "O2"
}

//This enum is to allow backward compatability with new Template names as well as format Temp names to be classNames
export enum TemplateClassNames {
	"Apollo" = "Apollo",
	"Classic" = "Apollo",
	"Studio 54" = "Studio54",
	"Bold" = "Studio54",
	"O2" = "O2",
	"Fun" = "O2"
}


export enum HeaderAllTemplates {
	left = 'left',
	center = 'center',
	right = 'right'
}

export enum MainEventBannerLayoutTypesClassic {
	standard = 'standard',
	right_full = 'right_full',
	center = 'center',
	center_no_bg = 'center_no_bg',
	left_small = 'left_small',
	right_small = 'right_small'
}
export enum MainEventBannerLayoutTypesBold {
	standard = 'standard',
	right_full = 'right_full',
	center = 'center',
	center_no_bg = 'center_no_bg',
	left_small = 'left_small',
	right_small = 'right_small'
}
export enum MainEventBannerLayoutTypesFun {
	standard = 'standard',
	right_full = 'right_full',
	center = 'center',
	center_no_bg = 'center_no_bg',
	left_small = 'left_small',
	right_small = 'right_small'
}

export enum SpeakerLayoutTypesClassic {
	standard = 'standard',
	small_horizontal = 'small_horizontal',
	staggered = 'staggered',
	long_card = 'long_card',
	solid = 'solid',
	small_vertical = 'small_vertical'
}
export enum SpeakerLayoutTypesBold {
	standard = 'standard',
	small_horizontal = 'small_horizontal',
	staggered = 'staggered',
	long_card = 'long_card',
	solid = 'solid',
	small_vertical = 'small_vertical'
}
export enum SpeakerLayoutTypesFun {
	standard = 'standard',
	small_horizontal = 'small_horizontal',
	staggered = 'staggered',
	long_card = 'long_card',
	solid = 'solid',
	small_vertical = 'small_vertical'
}



export enum AgendaLayoutTypesClassic {
	standard = 'standard',
	ltr = 'ltr',
	ltr_even_split = 'ltr_even_split',
	contained_card = 'contained_card',
	vertical_card = 'vertical_card',
	vertical_card_with_featured = 'vertical_card_with_featured',
	standard_no_image = 'standard_no_image',
	contained_card_no_image = 'contained_card_no_image',
	// these were not templates
	// contained_card_hover = 'contained_card_hover',
	// featured_live_session = 'featured_live_session',
}
export enum AgendaLayoutTypesBold {
	standard = 'standard',
	ltr = 'ltr',
	ltr_even_split = 'ltr_even_split',
	contained_card = 'contained_card',
	vertical_card = 'vertical_card',
	vertical_card_with_featured = 'vertical_card_with_featured',
	standard_no_image = 'standard_no_image',
	contained_card_no_image = 'contained_card_no_image',
	
}
export enum AgendaLayoutTypesFun {
	standard = 'standard',
	ltr = 'ltr',
	ltr_even_split = 'ltr_even_split',
	contained_card = 'contained_card',
	vertical_card = 'vertical_card',
	vertical_card_with_featured = 'vertical_card_with_featured',
	standard_no_image = 'standard_no_image',
	contained_card_no_image = 'contained_card_no_image',
}

export enum AboutLayoutTypesClassic {
	standard = 'standard',
	standard_flip = 'standard_flip',
	standard_full = 'standard_full',
	standard_full_flip = 'standard_full_flip',
	center = 'center',
	center_full = 'center_full',
	center_split = 'center_split'
}
export enum AboutLayoutTypesBold {
	standard = 'standard',
	standard_flip = 'standard_flip',
	standard_full = 'standard_full',
	standard_full_flip = 'standard_full_flip',
	center = 'center',
	center_full = 'center_full',
	center_split = 'center_split'
}
export enum AboutLayoutTypesFun {
	standard = 'standard',
	standard_flip = 'standard_flip',
	standard_full = 'standard_full',
	standard_full_flip = 'standard_full_flip',
	center = 'center',
	center_full = 'center_full',
	center_split = 'center_split'
}


export enum ProductsLayoutTypesClassic {
	standard = 'standard',
	grid = 'grid',
	vertical_list = 'vertical_list'
}
export enum ProductsLayoutTypesBold {
	standard = 'standard',
	grid = 'grid',
	vertical_list = 'vertical_list'
}
export enum ProductsLayoutTypesFun {
	standard = 'standard',
	grid = 'grid',
	vertical_list = 'vertical_list'
}

export enum VideosLayoutTypesClassic {
	standard = 'standard',
	wide = 'wide',
	full = 'full',
	ltr = 'ltr'
}
export enum VideosLayoutTypesBold {
	standard = 'standard',
	wide = 'wide',
	full = 'full',
	ltr = 'ltr'
}
export enum VideosLayoutTypesFun {
	standard = 'standard',
	wide = 'wide',
	full = 'full',
	ltr = 'ltr'
}


export enum SponsorsLayoutTypesClassic {
	standard = 'standard',
	card_full = 'card_full',
	card_short = 'card_short',
	split = 'split',
}
export enum SponsorsLayoutTypesBold {
	standard = 'standard',
	card_full = 'card_full',
	card_short = 'card_short',
	split = 'split',
}
export enum SponsorsLayoutTypesFun {
	standard = 'standard',
	card_full = 'card_full',
	card_short = 'card_short',
	split = 'split',
}

export enum CalloutLayoutTypesClassic {
	standard = 'standard',
	no_border = 'no_border',
	custom_background = 'custom_background',
	ltr = 'ltr'
}
export enum CalloutLayoutTypesBold {
	standard = 'standard',
	no_border = 'no_border',
	custom_background = 'custom_background',
	ltr = 'ltr'
}
export enum CalloutLayoutTypesFun {
	standard = 'standard',
	no_border = 'no_border',
	custom_background = 'custom_background',
	ltr = 'ltr'
}






export type AllLayoutTypes =
	| SpeakerLayoutTypesClassic
	| AgendaLayoutTypesClassic
	| AboutLayoutTypesClassic
	| ProductsLayoutTypesClassic
	| SponsorsLayoutTypesClassic
	| CalloutLayoutTypesClassic
	| MainEventBannerLayoutTypesClassic
	| VideosLayoutTypesClassic
	| SpeakerLayoutTypesBold
	| AgendaLayoutTypesBold
	| AboutLayoutTypesBold
	| ProductsLayoutTypesBold
	| SponsorsLayoutTypesBold
	| CalloutLayoutTypesBold
	| MainEventBannerLayoutTypesBold
	| VideosLayoutTypesBold
	| SpeakerLayoutTypesFun
	| AgendaLayoutTypesFun
	| AboutLayoutTypesFun
	| ProductsLayoutTypesFun
	| SponsorsLayoutTypesFun
	| CalloutLayoutTypesFun
	| MainEventBannerLayoutTypesFun
	| VideosLayoutTypesFun;

export const LayoutTypesMap = {
	[TemplateNames.Classic]: {
		[PageModuleType.speakers]: SpeakerLayoutTypesClassic,
		[PageModuleType.agenda]: AgendaLayoutTypesClassic,
		[PageModuleType.about]: AboutLayoutTypesClassic,
		[PageModuleType.products]: ProductsLayoutTypesClassic,
		[PageModuleType.sponsors]: SponsorsLayoutTypesClassic,
		[PageModuleType.callout]: CalloutLayoutTypesClassic,
		[PageModuleType.main_event_banner]: MainEventBannerLayoutTypesClassic,
		[PageModuleType.videos]: VideosLayoutTypesClassic,
		[PageModuleType.broadcast]: {},
		[PageModuleType.questions]: {},
		[PageModuleType.documents]: {},
		[PageModuleType.feed]: {},
		[PageModuleType.embed_widget]: {},
		[PageModuleType.slideshows]: {},
		[PageModuleType.quizzes]: {},
		[PageModuleType.survey]: {},
		[PageModuleType.description]: {},
		[PageModuleType.similar_sessions]: {},
		[PageModuleType.blank]: {},
		[PageModuleType.people]: {},
	},
	[TemplateNames.Bold]: {
		[PageModuleType.speakers]: SpeakerLayoutTypesBold,
		[PageModuleType.agenda]: AgendaLayoutTypesBold,
		[PageModuleType.about]: AboutLayoutTypesBold,
		[PageModuleType.products]: ProductsLayoutTypesBold,
		[PageModuleType.sponsors]: SponsorsLayoutTypesBold,
		[PageModuleType.callout]: CalloutLayoutTypesBold,
		[PageModuleType.main_event_banner]: MainEventBannerLayoutTypesBold,
		[PageModuleType.videos]: VideosLayoutTypesBold,
		[PageModuleType.broadcast]: {},
		[PageModuleType.questions]: {},
		[PageModuleType.documents]: {},
		[PageModuleType.feed]: {},
		[PageModuleType.embed_widget]: {},
		[PageModuleType.slideshows]: {},
		[PageModuleType.quizzes]: {},
		[PageModuleType.survey]: {},
		[PageModuleType.description]: {},
		[PageModuleType.similar_sessions]: {},
		[PageModuleType.blank]: {},
		[PageModuleType.people]: {},
	},
	[TemplateNames.Fun]: {
		[PageModuleType.speakers]: SpeakerLayoutTypesFun,
		[PageModuleType.agenda]: AgendaLayoutTypesFun,
		[PageModuleType.about]: AboutLayoutTypesFun,
		[PageModuleType.products]: ProductsLayoutTypesFun,
		[PageModuleType.sponsors]: SponsorsLayoutTypesFun,
		[PageModuleType.callout]: CalloutLayoutTypesFun,
		[PageModuleType.main_event_banner]: MainEventBannerLayoutTypesFun,
		[PageModuleType.videos]: VideosLayoutTypesFun,
		[PageModuleType.broadcast]: {},
		[PageModuleType.questions]: {},
		[PageModuleType.documents]: {},
		[PageModuleType.feed]: {},
		[PageModuleType.embed_widget]: {},
		[PageModuleType.slideshows]: {},
		[PageModuleType.quizzes]: {},
		[PageModuleType.survey]: {},
		[PageModuleType.description]: {},
		[PageModuleType.similar_sessions]: {},
		[PageModuleType.blank]: {},
		[PageModuleType.people]: {},
	}
};
